export default function IconFlashColor({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M8.02723 23.9311L11.0093 12.9967H7.0332L10.0153 1.06836H17.9675L12.9973 9.02061H17.9675L8.02723 23.9311Z"
        fill="#FFEF5E"
      />
      <path
        d="M14.4904 9.02062H12.9973L17.9675 1.06836H10.0153L7.0332 12.9967H10.5143L14.4904 9.02062Z"
        fill="#FFF9BF"
      />
      <path
        d="M8.02723 23.9311L11.0093 12.9967H7.0332L10.0153 1.06836H17.9675L12.9973 9.02061H17.9675L8.02723 23.9311Z"
        stroke="#191919"
        strokeWidth="1.03906"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
